<template>
  <v-card>
    <v-card-title>{{ shouldUpdate ? `Обновить кросс-сейл` : `Добавить кросс-сейл` }}</v-card-title>
    <v-card-text>
      <IngredientCell
        :item="selectedIngredient"
        @click="itemSelect" />
      <v-text-field
        v-model.number="priority"
        type="number"
        outlined
        hide-details
        dense
        label="Приоритет"
        class="mt-4" />
      <v-dialog
        v-model="ingredientsSelectionDialog"
        max-width="700"
      >
        <IngredientsSelectionDialog
          @select="select"
          :selectedIngredients="selectedIngredients"
        /> </v-dialog
    ></v-card-text>
    <v-card-actions>
      <v-row
        class="ma-0"
        justify="center"
        no-gutters
      >
        <v-btn
          :color="'primary'"
          depressed
          @click="confirm"
          class="mr-3"
          :loading="loading"
          :disabled="!selectedIngredient"
          >{{ shouldUpdate ? 'Обновить' : 'Добавить' }}
        </v-btn>
        <v-btn
          v-if="shouldUpdate"
          class="white--text"
          depressed
          color="red"
          @click="removeDialog = true"
          :disabled="loading"
          >{{ 'Удалить' }}
        </v-btn>
        <v-btn
          depressed
          color=""
          @click="close"
          class="ml-3"
          :disabled="loading"
        >
          Отменить
        </v-btn>
      </v-row>
    </v-card-actions>
    <!-- Диалог удаления -->
    <v-dialog
      v-model="removeDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>Удалить</v-card-title>
        <v-card-text>Удалить выбранный кросс-сейл?</v-card-text>
        <v-card-actions>
          <v-btn
            v-if="shouldUpdate"
            class="white--text"
            depressed
            color="primary"
            @click="remove"
            >{{ 'Удалить' }}
          </v-btn>
          <v-btn
            depressed
            color=""
            @click="removeDialog = false"
            class="ml-3"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import IngredientsSelectionDialog from './ingredientSelection/IngredientsSelectionDialog.vue'
  import IngredientCell from './ingredientSelection/IngredientCell.vue'

  export default {
    name: 'CrossSellDialogItem',
    components: { IngredientsSelectionDialog, IngredientCell },
    props: {
      selectedIngredients: [],
      item: {
        type: Object,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      shouldUpdate: false,
      crossSellItem: null,
      selectedIngredient: null,
      ingredientsSelectionDialog: false,
      removeDialog: false,
      priority: 100
    }),
    computed: {
      currentSelectedItem() {
        return {
          ...this.selectedIngredient,
          priority: this.priority
        }
      }
    },
    methods: {
      itemSelect() {
        this.ingredientsSelectionDialog = true
      },
      select(value) {
        this.ingredientsSelectionDialog = false
        this.selectedIngredient = value
      },
      clear() {
        this.selectedIngredient = null
        this.priority = 100
      },
      close() {
        this.clear()
        this.$emit('close')
      },
      remove() {
        this.removeDialog = false
        this.clear()
        this.$emit('remove')
      },
      confirm() {
        if (this.shouldUpdate) {
          this.$emit('update', this.currentSelectedItem)
        } else {
          this.$emit('added', this.currentSelectedItem)
        }

        this.clear()
      }
    },
    mounted() {
      if (this.item != null) {
        this.selectedIngredient = this.item
        this.priority = this.item.priority
        this.shouldUpdate = true
      }
    }
  }
</script>
